// src/components/ThemeToggle.js
import React, { useContext, useState } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { FaMoon } from 'react-icons/fa';
import { FaSun } from 'react-icons/fa';

const ThemeToggle = () => {
  const { toggleTheme } = useContext(ThemeContext);

  const [isFirstImage, setIsFirstImage] = useState(true);
  const toggleImage = ()=>{
    setIsFirstImage(!isFirstImage) ;
  }
  
  const handleClick = () => {
    toggleTheme(); 
    toggleImage();
  };

  return (
    <button
      onClick={handleClick}
      className="p-2 bg-gray-300 dark:bg-gray-700 rounded"
    >
      {isFirstImage ? (
        <FaSun />
      ) : (
        <FaMoon />
      )}
    </button>
  );
};

export default ThemeToggle;
